module.exports = __webpack_public_path__ + "media/MRI22.78124135.mp3";